import { render, staticRenderFns } from "./TenantReportHeader.vue?vue&type=template&id=465d4fb2&"
import script from "./TenantReportHeader.vue?vue&type=script&lang=js&"
export * from "./TenantReportHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports